import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  DashboardPageFormBody,
  DashboardPageFormField,
  DashboardPageFormToggleSection,
} from '@shigo-ui/dashboard-ui';
import { AutocompleteMultiSelect, Textarea } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { usePlacementIabCategoriesQuery } from '../../hooks';
import type { PlacementFormValue } from '../../placementFormSchema';

export function PlacementExclusionsFields() {
  'use no memo';
  const { control, register } = useFormContext<PlacementFormValue>();
  const enabled = useWatch({ control, name: 'exclusionsEnabled' });
  const iabCategoriesQuery = usePlacementIabCategoriesQuery(enabled);
  const iabCategoryOptions = (iabCategoriesQuery.data ?? []).map((category) => ({
    id: category.id,
    label: category.name,
  }));
  return (
    <DashboardPageFormBody width="lg">
      <Controller
        control={control}
        name="exclusionsEnabled"
        render={({ field }) => (
          <DashboardPageFormToggleSection
            label={dashboardT('placements.exclusionsEnabled')}
            checked={field.value}
            onCheckedChange={field.onChange}
          >
            <div className="grid gap-5 md:grid-cols-2">
              <DashboardPageFormField
                label={dashboardT('placements.advertiserDomains')}
                htmlFor="placement-advertiser-domains"
              >
                <Textarea
                  id="placement-advertiser-domains"
                  rows={7}
                  placeholder={dashboardT('placements.commaOrLine')}
                  {...register('advertiserDomainsText')}
                />
              </DashboardPageFormField>
              <DashboardPageFormField
                label={dashboardT('placements.excludedCreativeIds')}
                htmlFor="placement-creative-ids"
              >
                <Textarea
                  id="placement-creative-ids"
                  rows={7}
                  placeholder={dashboardT('placements.commaOrLine')}
                  {...register('excludedCreativeIdsText')}
                />
              </DashboardPageFormField>
              <div className="md:col-span-2">
                <Controller
                  control={control}
                  name="excludedIabCategoryIds"
                  render={({ field }) => (
                    <DashboardPageFormField label={dashboardT('placements.excludedIab')}>
                      <AutocompleteMultiSelect
                        label={dashboardT('placements.excludedIab')}
                        options={iabCategoryOptions}
                        value={field.value}
                        onValueChange={field.onChange}
                        loading={iabCategoriesQuery.isLoading}
                        maxResults={iabCategoryOptions.length}
                        placeholder={dashboardT('placements.searchIabCategories')}
                        emptyMessage={dashboardT('placements.noIabCategories')}
                      />
                    </DashboardPageFormField>
                  )}
                />
              </div>
            </div>
          </DashboardPageFormToggleSection>
        )}
      />
      {enabled ? null : (
        <p className="text-muted-foreground text-sm">
          {dashboardT('placements.exclusionsDisabled')}
        </p>
      )}
    </DashboardPageFormBody>
  );
}
